import React from 'react';
import { Route, Routes } from 'react-router-dom';

import CertificatePage from './CertificatePage';

function CertificatesRoute() {
	return (
		<Routes>
			<Route path="/" element={<CertificatePage />} />
		</Routes>
	);
}

export default CertificatesRoute;
